import { render } from "./PayZone.vue?vue&type=template&id=4f465371"
import script from "./PayZone.vue?vue&type=script&lang=js"
export * from "./PayZone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__